import { Injectable, OnInit } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../../auth';
import { Globals } from '../../globals';
import { Observable } from 'rxjs';

@Injectable()
export class NewProjectEditService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }    

    /**
     * Save new project
     * @param project project object
     * @param edition SCM ediction
     */
     saveProject(project, useDigitalExport: boolean) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('projectBody', JSON.stringify(project))
            .set('autoGenerate', project.generateCustomerSUA)        
            .set('useDigitalExport', JSON.stringify(useDigitalExport));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }    

    /**
     * Update existing project
     * @param project project object
     * @param edition SCM ediction
     */
    updateProject(project, useDigitalExport: boolean) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/' + project.id;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('projectBody', JSON.stringify(project))
            .set('autoGenerate', project.generateCustomerSUA)
            .set('useDigitalExport', JSON.stringify(useDigitalExport));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get all receivers
     */
    getAllReceivers() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiverPerson';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Deletes a receiver based on ID.
     */
    deleteRecieverPerson(receiverId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiverPerson/delete/' + receiverId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }

    /**
     * Get a list of names of all unique default projects
     *
     */
    getAllUniqueProjectNames() : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/default-project/getalluniqueprojectnames';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    getHeadSupplierByProjectName(projectName: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/employer/project/gov?projectName=${projectName}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    getCustomerSupplierByProjectName(projectName: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/employer/project/comp?projectName=${projectName}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    dissolveProjectHierarchy(projectId: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/default-project/dissolve-hierarchy`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('projectId', projectId);

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'})
    }

    findHeadProjectByName(projectName: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/default-project/head-project?projectName=${projectName}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, { headers: requestHeaders, responseType: 'json' });
    }

    findCustomerProjectByName(projectName: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/default-project/customer-project?projectName=${projectName}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, { headers: requestHeaders, responseType: 'json' });
    }

    supplierExistsInHierarchy(headProjectId: string, supplierId: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/default-project/hierarchy/${headProjectId}?supplierId=${supplierId}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, { headers: requestHeaders, responseType: 'json' });
    }
    
    /**
     * Update existing receiver
     * @param receiver receiver object
     */
    updateReceiver(receiver) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/receiverPerson';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('receiverPersonBody', JSON.stringify(receiver));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }
    
    /**
     * Get all addressCodes
     * @returns 
     */
     getAllAddressCodes() {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/addressCode';

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    /**
     * Get a addressCode ID based on a name
     */
     deleteAddressCode(addressCodeId) {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/addressCode/delete/' + addressCodeId;

        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'json'});
    }
    
    /**
     * Update new receiver
     * @param receiver receiver object
     */
    updateAddressCode(receiver) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/addressCode';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
        .set('addressCodeBody', JSON.stringify(receiver));

        return this.http.put(url, body, {headers: requestHeaders, responseType: 'json'});
    }
}
